// eslint-disable-next-line import/no-anonymous-default-export
import {EDIT_TABLE_PAYLOAD, EMPTY_EDIT_TABLE_PAYLOAD} from "../Types/types";

export default function (state = {data: null}, action: any) {
  switch (action.type) {
    case EDIT_TABLE_PAYLOAD:
      return {
        ...state,
        data: action.payload,
      }
    case EMPTY_EDIT_TABLE_PAYLOAD:
      return{
        data:null
      }
    default:
      return state
  }
}